export const ADD_TO_BAG_TEST_ID = 'add-to-bag';
export const ADD_TO_BAG_LOADING_TEST_ID = 'add-to-bag-loading';
